import { reactive } from 'vue';
import { i18n } from '@/i18n';

export type ConfirmVariant = 'default' | 'destructive';

export interface ConfirmOptions {
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  variant?: ConfirmVariant;
}

export const confirmState = reactive({
  open: false,
  title: '',
  description: '',
  confirmText: i18n.global.t('common.confirm'),
  cancelText: i18n.global.t('common.cancel'),
  variant: 'default' as ConfirmVariant,
});

let pendingResolve: ((value: boolean) => void) | null = null;

export function confirm(options: ConfirmOptions): Promise<boolean> {
  return new Promise((resolve) => {
    pendingResolve = resolve;
    confirmState.title = options.title;
    confirmState.description = options.description ?? '';
    confirmState.confirmText = options.confirmText ?? i18n.global.t('common.confirm');
    confirmState.cancelText = options.cancelText ?? i18n.global.t('common.cancel');
    confirmState.variant = options.variant ?? 'default';
    confirmState.open = true;
  });
}

export function resolveConfirm(value: boolean) {
  confirmState.open = false;
  pendingResolve?.(value);
  pendingResolve = null;
}
